<template>
  <div class="tabs">
   <div class="tabs-box">
    <div v-for="tab in tabs" :key="tab.id" class="tab-item" :class="{'active': activeName === tab.id}" @click="emitUpdate(tab.id)">
      {{ tab.title }}
    </div>
   </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    },
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      activeName: this.value,
    };
  },
  methods: {
    emitUpdate(value) {
      this.activeName = value;
      this.$emit('change', value);
    }
  }
}
</script>

<style lang='scss' scoped>
.tabs-box{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #d4ded4;
}
.tab-item {
  font-size: 20px;
  line-height: 120%;
  padding: 10px 24px;
  cursor: pointer;
  color: #0A0A0A;
  text-align: center;
}
.active {
  color: #FF4D0A;
  position: relative;
  &::after {
    position: absolute;
    bottom: 0;
    left: 0;
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background-color: #FF4D0A;
  }
}
@media screen and (max-width: 850px) { 
  .tab-item {
    font-size: 18px;
    line-height: 120%;
    flex: 1;
  }
}
</style>